import { Component, computed, inject } from '@angular/core';
import { ButtonComponent } from "../../components/primitives/button/button.component";
import { AuthService } from 'src/app/services/auth.service';
import { StateService } from 'src/app/services/state.service';
import { IonIcon } from '@ionic/angular/standalone';
import { toSignal } from '@angular/core/rxjs-interop';
import { AddressType, PlaceAutocompleteResult } from '@googlemaps/google-maps-services-js';
import { addIcons } from 'ionicons';
import { cart, chevronForward, location } from 'ionicons/icons';
import { UiService } from 'src/app/services/ui.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: true,
  imports: [RouterModule, IonIcon, ButtonComponent],
})
export class NavbarComponent {
  private $auth = inject(AuthService);
  private $state = inject(StateService);
  private $ui = inject(UiService);

  public session = toSignal(this.$state.bSession);
  public cart = toSignal(this.$state.bCart);
  public isLoggedIn = this.$state.isLoggedIn;
  public combinedItemCount = computed<number>(() => this.cart()?.combinedItemCount ?? 0);
  
  public noAddressSet = computed<boolean>(() => !this.session()?.address?.address?.address_components);
  public address = computed(() =>  {
    const placeDetails = this.session()?.address;
    if (!placeDetails?.address?.address_components) return "Set Address";
    const addressComponents = placeDetails.address.address_components;
    const streetNumber = addressComponents.find(comp => comp.types.includes(AddressType.street_number))?.long_name || '';
    const route = addressComponents.find(comp => comp.types.includes(AddressType.route))?.long_name || '';
    const aptSuiteFloor = placeDetails.aptSuiteFloor;

    const primary = aptSuiteFloor
      ? `${aptSuiteFloor}/${streetNumber} ${route}`
      : (placeDetails.selectedAddress as PlaceAutocompleteResult).structured_formatting.main_text;
    const secondary = (placeDetails.selectedAddress as PlaceAutocompleteResult)?.structured_formatting?.secondary_text;
    return `${primary}, ${secondary}`;
  });

  constructor() {
    addIcons({ cart, location, chevronForward })
  }

  login() {
    this.$auth.showLogin();
  }
  
  showCart() {
    this.$ui.showCartCheckout.next();
  }

  editAddress() {
    this.$ui.setAddress.next(this.session()?.address);
  }

}
